import cn from 'classnames';
import {ChangeEvent, FC, useId} from 'react';
import {PhotoRemoveIcon} from 'shared/icons';
import {isPassportPhotoFile, PASSPORT_PHOTO_ACCEPT} from '../../../model';
import styles from './PassportPhotoMultiUpload.module.css';

export type PassportPhotoMultiItem = {
	id: string;
	label: string;
	previewUrl: string | null;
};

type Props = {
	items: PassportPhotoMultiItem[];
	onSelect: (slotId: string, file: File) => void;
	onRemove: (slotId: string) => void;
	className?: string;
};

type SlotCellProps = {
	item: PassportPhotoMultiItem;
	onSelect: (slotId: string, file: File) => void;
	onRemove: (slotId: string) => void;
};

const SlotCell: FC<SlotCellProps> = ({item, onSelect, onRemove}) => {
	const inputId = useId();

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0];
		event.target.value = '';

		if (!file || !isPassportPhotoFile(file)) {
			return;
		}

		onSelect(item.id, file);
	};

	return (
		<div className={styles.slot}>
			{item.previewUrl ? (
				<div className={styles.previewWrap}>
					<img className={styles.preview} src={item.previewUrl} alt="" />
					<button
						type="button"
						className={styles.removeButton}
						aria-label={`Удалить: ${item.label}`}
						onClick={() => onRemove(item.id)}
					>
						<PhotoRemoveIcon />
					</button>
				</div>
			) : (
				<>
					<label htmlFor={inputId} className={styles.addButton} aria-label={`Добавить: ${item.label}`}>
						<span className={styles.plusIcon} aria-hidden>
							+
						</span>
					</label>
					<input
						id={inputId}
						className={styles.input}
						type="file"
						accept={PASSPORT_PHOTO_ACCEPT}
						onChange={handleChange}
					/>
				</>
			)}
			<span className={styles.caption}>{item.label}</span>
		</div>
	);
};

/** Галерея фото со слотами и подписями под каждым. */
export const PassportPhotoMultiUpload: FC<Props> = ({items, onSelect, onRemove, className}) => {
	return (
		<div className={cn(styles.root, className)}>
			{items.map((item) => (
				<SlotCell key={item.id} item={item} onSelect={onSelect} onRemove={onRemove} />
			))}
		</div>
	);
};
